import { ALL_AI_PROVIDER_TYPES } from './types';
import type { AiProviderType } from './types';

export interface AiProviderTypeOption {
  value: AiProviderType | (typeof ALL_AI_PROVIDER_TYPES)[number];
  label: string;
  /** `false` for every provider type this build cannot actually create yet (spec FR-004). */
  enabled: boolean;
}

/**
 * Every provider type the form can list, in display order.
 *
 * Only `anthropic` is enabled today — everything else renders disabled with a
 * "Coming soon" label rather than being omitted, so the form visually
 * communicates what is on the roadmap without offering a third-party CRUD
 * flow that does not exist (spec 084 Assumptions).
 */
export const AI_PROVIDER_TYPE_OPTIONS: AiProviderTypeOption[] = [
  { value: 'anthropic', label: 'Anthropic', enabled: true },
  { value: 'openai', label: 'OpenAI', enabled: false },
  { value: 'mistral', label: 'Mistral', enabled: false },
];

export const COMING_SOON_LABEL = 'Coming soon';

export function providerTypeLabel(value: string): string {
  return (
    AI_PROVIDER_TYPE_OPTIONS.find((option) => option.value === value)?.label ??
    value
  );
}
